import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  editHeaderCss: css`
    position: sticky;
    top: 0;
    z-index: 1;
  `,
  infoSheetFooter: css`
    position: fixed;
    bottom: 0;
    background: ${colors.gray00};
    width: 100%;
    box-shadow: 0 -2px 10px #ddd;
    padding: 10px 16px;
  `,
  buttonLoader: css`
    margin-top: -6px;
    margin-inline-end: -2px;
    margin-bottom: 0;
    margin-inline-start: -6px;
  `,
  errorText: css`
    color: ${colors.danger50};
  `,
  coveragesError: css`
    display: flex;
    background-color: #fee6da;
    padding: 4px 16px;
    align-items: center;
  `,
  errorIcon: css`
    padding-inline-end: 16px;
  `,
  noBottomPadding: css`
    padding-bottom: 0px;
  `,
  openChangeHistory: css`
    padding: 8px 0;
  `,
}
